import {
    GoogleOAuthUserApi, SheetConfigurationApi, SheetConfigurationForecastDownloadFromSheetRuleApi, SheetConfigurationForecastUploadToSheetRuleApi, SheetExcelConfigurationApi, SheetExcelGenerationIndicatorDepthRuleApi,
    SheetExcelGenerationValueWriteRuleApi, SheetForecastApi, SheetForecastFileApi, SheetForecastFileStatusApi, SheetForecastFileTypeApi, SheetForecastFileUserAccessApi,
    SheetForecastInputMethodApi, SheetForecastNotificationApi, SheetForecastRelatedSheetApi, SheetGoogleConfigurationApi, SheetGoogleTemplateCopiedRangeValueTypeApi
} from 'for-straction-service-api';
import { entityLifecycleActionSet, nestedEntityLifecycleActionSet, networkAPIAction } from '../utils/actionCreatorsFactory';
import { ActionType, NetworkActionPrefix } from '../utils/constants';

const googleOAuthUserActionSet = entityLifecycleActionSet('GoogleOAuthUser', 'GOOGLE_OAUTH_USER', 'googleOAuthUser', GoogleOAuthUserApi, {
    delete: true,
    loadAll: 'googleOAuthUserLoadAllCurrentUserHasAccessToGet'
});
export const loadAllGoogleOAuthUsers = () => googleOAuthUserActionSet.loadAllGoogleOAuthUsers();
export const removeGoogleOAuthUser = googleOAuthUserID => googleOAuthUserActionSet.removeGoogleOAuthUser(googleOAuthUserID);

const sheetConfigurationActionSet = entityLifecycleActionSet('SheetConfiguration', 'SHEET_CONFIGURATION', 'sheetConfiguration', SheetConfigurationApi, {
    add: true,
    delete: true,
    edit: true,
    loadAll: true
});
export const addSheetConfiguration = (sheetConfiguration, sync) => sheetConfigurationActionSet.addSheetConfiguration(sheetConfiguration, sync);
export const editSheetConfiguration = (sheetConfiguration, sync) => sheetConfigurationActionSet.editSheetConfiguration(sheetConfiguration, sync);
export const editAllSheetConfigurations = (sheetConfigurations, sync) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({
            type: ActionType.EDIT_ALL_SHEET_CONFIGURATIONS,
            sheetConfigurations
        });

        if (!sync) {
            resolve();
        }
        else {
            dispatch(networkAPIAction(SheetConfigurationApi, 'sheetConfigurationEditAllPut', NetworkActionPrefix.EDIT_ALL_SHEET_CONFIGURATIONS_PREFIX, { sheetConfigurations }, sheetConfigurations))
                .then(resolve, reject);
        }
    });
export const loadAllSheetConfigurations = () => sheetConfigurationActionSet.loadAllSheetConfigurations();
export const removeSheetConfiguration = sheetConfigurationID => sheetConfigurationActionSet.removeSheetConfiguration(sheetConfigurationID);
export const syncSheetConfiguration = sheetConfiguration => sheetConfigurationActionSet.syncSheetConfiguration(sheetConfiguration);

const sheetExcelConfigurationActionSet = entityLifecycleActionSet('SheetExcelConfiguration', 'SHEET_EXCEL_CONFIGURATION', 'sheetExcelConfiguration', SheetExcelConfigurationApi, {
    loadAll: true,
    load: true,
    add: true,
    edit: true,
    delete: true
}, true);
export const loadAllSheetExcelConfigurations = () => sheetExcelConfigurationActionSet.loadAllSheetExcelConfigurations();
export const loadSheetExcelConfiguration = sheetExcelConfigurationID => sheetExcelConfigurationActionSet.loadSheetExcelConfiguration(sheetExcelConfigurationID);
export const addSheetExcelConfiguration = (sheetExcelConfiguration, sync, reloadAfterSync) => sheetExcelConfigurationActionSet.addSheetExcelConfiguration(sheetExcelConfiguration, sync, reloadAfterSync);
export const editSheetExcelConfiguration = (sheetExcelConfiguration, sync, reloadAfterSync) => sheetExcelConfigurationActionSet.editSheetExcelConfiguration(sheetExcelConfiguration, sync, reloadAfterSync);
export const removeSheetExcelConfiguration = sheetExcelConfigurationID => sheetExcelConfigurationActionSet.removeSheetExcelConfiguration(sheetExcelConfigurationID);

export const importAndProcessExcelFile = (file, sheetExcelConfigurationID) => (dispatch) => {
    dispatch({
        type: ActionType.IMPORT_AND_PROCESS_EXCEL_FILE,
        sheetExcelConfigurationID,
        file
    });

    dispatch(syncProcessedExcelFile(file, sheetExcelConfigurationID));
};
export const syncProcessedExcelFile = (file, sheetExcelConfigurationID) =>
    networkAPIAction(new SheetExcelConfigurationApi(), 'sheetExcelConfigurationImportAndProcessExcelFilePut', NetworkActionPrefix.IMPORT_AND_PROCESS_EXCEL_FILE_PREFIX, { file, sheetExcelConfigurationID }, file, sheetExcelConfigurationID);

export const reprocessStoredExcelFile = sheetExcelConfigurationID =>
    networkAPIAction(new SheetExcelConfigurationApi(), 'sheetExcelConfigurationReprocessStoredExcelFileGet', NetworkActionPrefix.REPROCESS_STORED_EXCEL_FILE_PREFIX, { sheetExcelConfigurationID }, sheetExcelConfigurationID);

export const storeExcelFileAndSetURIToConfiguration = (file, sheetExcelConfigurationID) => (dispatch) => {
    dispatch({
        type: ActionType.STORE_EXCEL_FILE_AND_SET_URI_TO_CONFIGURATION,
        sheetExcelConfigurationID,
        file
    });

    dispatch(syncStoredExcelFile(file, sheetExcelConfigurationID));
};
export const syncStoredExcelFile = (file, sheetExcelConfigurationID) =>
    networkAPIAction(new SheetExcelConfigurationApi(), 'sheetExcelConfigurationStoreExcelFileAndSetURIToConfigurationPut', NetworkActionPrefix.STORE_EXCEL_FILE_AND_SET_URI_TO_CONFIGURATION_PREFIX, { file, sheetExcelConfigurationID }, file, sheetExcelConfigurationID);

export const loadExcelSpreadsheet = sheetExcelConfigurationID =>
    networkAPIAction(new SheetExcelConfigurationApi(), 'sheetExcelConfigurationGetExcelSpreadsheetGet', NetworkActionPrefix.LOAD_EXCEL_SPREADSHEET_PREFIX, { sheetExcelConfigurationID }, sheetExcelConfigurationID);

export const createExcelFile = (excelGenerationSettings, fileName) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({
            type: ActionType.CREATE_EXCEL_FILE,
            excelGenerationSettings
        });

        dispatch(networkAPIAction(SheetExcelConfigurationApi, 'sheetExcelConfigurationCreateExcelFilePut', NetworkActionPrefix.CREATE_EXCEL_FILE_PREFIX, { excelGenerationSettings }, excelGenerationSettings))
            .then((response) => {
                if (response) {
                    const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response}`,
                        linkElement = document.createElement('a');

                    linkElement.setAttribute('href', linkSource);
                    linkElement.setAttribute('download', fileName);
                    linkElement.click();
                }
            })
            .then(resolve, reject);
    });

export const checkExcelAuthentication = sheetExcelConfigurationID =>
    networkAPIAction(SheetExcelConfigurationApi, 'sheetExcelConfigurationCheckAuthenticationGet', NetworkActionPrefix.CHECK_EXCEL_AUTHENTICATION_PREFIX, { sheetExcelConfigurationID }, sheetExcelConfigurationID);

export const createExcelConfigurationFromShareURL = shareURL =>
    networkAPIAction(SheetExcelConfigurationApi, 'sheetExcelConfigurationCreateFromShareURLGet', NetworkActionPrefix.CREATE_EXCEL_CONFIGURATION_FROM_SHARE_URL_PREFIX, { shareURL }, shareURL);

export const testExcelShareURL = shareURL =>
    networkAPIAction(SheetExcelConfigurationApi, 'sheetExcelConfigurationTestShareURLGet', NetworkActionPrefix.TEST_EXCEL_SHARE_URL_PREFIX, { shareURL }, shareURL);

const sheetGoogleConfigurationActionSet = entityLifecycleActionSet('SheetGoogleConfiguration', 'SHEET_GOOGLE_CONFIGURATION', 'sheetGoogleConfiguration', SheetGoogleConfigurationApi, {
    add: true,
    delete: true,
    edit: true,
    loadAll: true
});
export const addSheetGoogleConfiguration = (sheetGoogleConfiguration, sync) => sheetGoogleConfigurationActionSet.addSheetGoogleConfiguration(sheetGoogleConfiguration, sync);
export const editSheetGoogleConfiguration = (sheetGoogleConfiguration, sync) => sheetGoogleConfigurationActionSet.editSheetGoogleConfiguration(sheetGoogleConfiguration, sync);
export const loadAllSheetGoogleConfigurations = () => sheetGoogleConfigurationActionSet.loadAllSheetGoogleConfigurations();
export const removeSheetGoogleConfiguration = sheetGoogleConfigurationID => sheetGoogleConfigurationActionSet.removeSheetGoogleConfiguration(sheetGoogleConfigurationID);
export const syncSheetGoogleConfiguration = sheetGoogleConfiguration => sheetGoogleConfigurationActionSet.syncSheetGoogleConfiguration(sheetGoogleConfiguration);

export const checkGoogleAuthentication = sheetGoogleConfigurationID =>
    networkAPIAction(new SheetGoogleConfigurationApi(), 'sheetGoogleConfigurationCheckAuthenticationGet', NetworkActionPrefix.CHECK_GOOGLE_AUTHENTICATION_PREFIX, { sheetGoogleConfigurationID }, sheetGoogleConfigurationID);

export const loadGoogleSpreadsheet = sheetGoogleConfigurationID =>
    networkAPIAction(new SheetGoogleConfigurationApi(), 'sheetGoogleConfigurationGetLightGoogleSpreadsheetGet', NetworkActionPrefix.LOAD_GOOGLE_SPREADSHEET_PREFIX, { sheetGoogleConfigurationID }, sheetGoogleConfigurationID);

export const copyRangesFromTemplateGoogleSheet = settings =>
    networkAPIAction(new SheetGoogleConfigurationApi(), 'sheetGoogleConfigurationCopyRangesFromTemplatePut', NetworkActionPrefix.COPY_RANGES_FROM_TEMPLATE_GOOGLE_SHEET_PREFIX, { settings }, settings);

export const cloneGoogleSheet = (sheetGoogleConfigurationID, cloneSettings) =>
    networkAPIAction(new SheetGoogleConfigurationApi(), 'sheetGoogleConfigurationCloneGoogleSheetGet', NetworkActionPrefix.CLONE_SHEET_GOOGLE_CONFIGURATION_PREFIX, { sheetGoogleConfigurationID, cloneSettings }, sheetGoogleConfigurationID, cloneSettings);

export const importAndProcessGoogleSheetsData = sheetGoogleConfigurationID => (dispatch) => {
    dispatch({
        type: ActionType.IMPORT_AND_PROCESS_GOOGLE_SHEETS_DATA,
        sheetGoogleConfigurationID
    });

    dispatch(syncProcessedGoogleSheet(sheetGoogleConfigurationID));
};
export const syncProcessedGoogleSheet = sheetGoogleConfigurationID =>
    networkAPIAction(new SheetGoogleConfigurationApi(), 'sheetGoogleConfigurationImportAndProcessGoogleSheetsDataGet', NetworkActionPrefix.IMPORT_AND_PROCESS_GOOGLE_SHEETS_DATA_PREFIX, { sheetGoogleConfigurationID }, sheetGoogleConfigurationID);

export const createGoogleSpreadsheetFromIndicators = (sheetGenerationSettings, createForecastSheet) =>
    networkAPIAction(new SheetGoogleConfigurationApi(), 'sheetGoogleConfigurationCreateGoogleSpreadsheetFromIndicatorsPut', NetworkActionPrefix.CREATE_GOOGLE_SPREADSHEET_FROM_INDICATORS_PREFIX, { sheetGenerationSettings, createForecastSheet }, sheetGenerationSettings, createForecastSheet);

export const createGoogleSpreadsheetFromFinancialProfitAndLossIndicators = () =>
    networkAPIAction(new SheetGoogleConfigurationApi(), 'sheetGoogleConfigurationCreateGoogleSpreadsheetFromFinancialProfitAndLossIndicatorsGet', NetworkActionPrefix.CREATE_GOOGLE_SPREADSHEET_FROM_FINANCIAL_PROFIT_AND_LOSS_INDICATORS_PREFIX);

export const dropSpreadsheetImportedResults = () => ({ type: ActionType.DROP_SPREADSHEET_IMPORTED_RESULTS });

export const dropSpreadsheet = () => ({ type: ActionType.DROP_SPREADSHEET });

export const dropGeneratedSheet = () => ({ type: ActionType.DROP_GENERATED_SHEET });

export const loadAllSheetForecastInputMethods = () => networkAPIAction(SheetForecastInputMethodApi, 'sheetForecastInputMethodLoadAllGet', NetworkActionPrefix.LOAD_ALL_SHEET_FORECAST_INPUT_METHODS_PREFIX);

export const loadAllSheetForecastFileStatuses = () => networkAPIAction(SheetForecastFileStatusApi, 'sheetForecastFileStatusLoadAllGet', NetworkActionPrefix.LOAD_ALL_SHEET_FORECAST_FILE_STATUSES_PREFIX);

export const loadAllSheetForecastFileTypes = () => networkAPIAction(SheetForecastFileTypeApi, 'sheetForecastFileTypeLoadAllGet', NetworkActionPrefix.LOAD_ALL_SHEET_FORECAST_FILE_TYPES_PREFIX);

const sheetForecastActionSet = entityLifecycleActionSet('SheetForecast', 'SHEET_FORECAST', 'sheetForecast', SheetForecastApi, {
    loadAll: true,
    load: true,
    add: true,
    edit: true,
    delete: true
}, true);
export const loadAllSheetForecasts = () => sheetForecastActionSet.loadAllSheetForecasts();
export const loadSheetForecast = sheetForecastID => sheetForecastActionSet.loadSheetForecast(sheetForecastID);
export const addSheetForecast = (sheetForecast, sync, reloadAfterSync) => sheetForecastActionSet.addSheetForecast(sheetForecast, sync, reloadAfterSync);
export const editSheetForecast = (sheetForecast, sync, reloadAfterSync) => sheetForecastActionSet.editSheetForecast(sheetForecast, sync, reloadAfterSync);
export const removeSheetForecast = sheetForecastID => sheetForecastActionSet.removeSheetForecast(sheetForecastID);

const sheetForecastFileActionSet = nestedEntityLifecycleActionSet('SheetForecastFile', 'SHEET_FORECAST_FILE', 'sheetForecast', 'sheetForecastFile', SheetForecastFileApi, {
    load: true,
    delete: true
}, true);

export const loadSheetForecastFile = (sheetForecastID, sheetForecastFileID) => sheetForecastFileActionSet.loadSheetForecastFile(sheetForecastID, sheetForecastFileID);
export const addSheetForecastFile = (sheetForecastID, sheetForecastFile, useTemplateCompany, templateID, withNotification, sync, reloadAfterSync) => (dispatch) => {
    dispatch({
        type: ActionType.ADD_SHEET_FORECAST_FILE,
        sheetForecastID,
        sheetForecastFileID: sheetForecastFile.ID,
        sheetForecastFile,
        useTemplateCompany,
        templateID,
        withNotification
    });

    if (!sync) {
        return Promise.resolve(sheetForecastFile.ID);
    }
    else {
        const result = dispatch(networkAPIAction(
            SheetForecastFileApi, 'sheetForecastFileAddPut', NetworkActionPrefix.ADD_SHEET_FORECAST_FILE_PREFIX, { sheetForecastID, sheetForecastFile, sheetForecastFileID: sheetForecastFile.ID, useTemplateCompany, templateID, withNotification }, sheetForecastFile, { useTemplateCompany, templateID, withNotification }
        ));

        if (!reloadAfterSync) {
            return result;
        }
        else {
            return result.then(response => dispatch(loadSheetForecastFile(sheetForecastID, response)));
        }
    }
};
export const editSheetForecastFile = (sheetForecastID, sheetForecastFile, withNotification, sync, reloadAfterSync) => (dispatch) => {
    dispatch({
        type: ActionType.EDIT_SHEET_FORECAST_FILE,
        sheetForecastID,
        sheetForecastFileID: sheetForecastFile.ID,
        sheetForecastFile,
        withNotification
    });

    if (!sync) {
        return Promise.resolve(sheetForecastFile.ID);
    }
    else {
        const result = dispatch(networkAPIAction(
            SheetForecastFileApi, 'sheetForecastFileEditPut', NetworkActionPrefix.EDIT_SHEET_FORECAST_FILE_PREFIX, { sheetForecastID, sheetForecastFile, sheetForecastFileID: sheetForecastFile.ID, withNotification }, sheetForecastFile, { withNotification }
        ));

        if (!reloadAfterSync) {
            return result;
        }
        else {
            return result.then(response => dispatch(loadSheetForecastFile(sheetForecastID, response)));
        }
    }
};

export const importForecastData = (sheetForecastID, sheetForecastFileID, reloadAfterSync = false) => (dispatch) => {
    const promise = dispatch(
        networkAPIAction(SheetForecastFileApi, 'sheetForecastFileImportForecastDataGet', NetworkActionPrefix.IMPORT_FORECAST_SPREADSHEET_PREFIX, { sheetForecastID, sheetForecastFileID }, sheetForecastFileID
        ));

    if (reloadAfterSync) {
        promise.then(() => dispatch(loadSheetForecastFile(sheetForecastID, sheetForecastFileID)));
    }
};

export const generateForecastSheetContents = (sheetForecastID, sheetForecastFileID, reloadAfterSync = false) => (dispatch) => {
    const promise = dispatch(
        networkAPIAction(SheetForecastFileApi, 'sheetForecastFileGenerateForecastSheetContentsGet', NetworkActionPrefix.GENERATE_FORECAST_SHEET_CONTENTS_PREFIX, { sheetForecastID, sheetForecastFileID }, sheetForecastFileID
        ));

    if (reloadAfterSync) {
        promise.then(() => dispatch(loadSheetForecastFile(sheetForecastID, sheetForecastFileID)));
    }
};

export const aggregateSheetForecastFileData = (forecastFileID, preview, { sumPeriodValues } = {}) =>
    networkAPIAction(SheetForecastFileApi, 'sheetForecastFileAggregateDataGet', NetworkActionPrefix.AGGREGATE_SHEET_FORECAST_FILE_DATA_PREFIX, { forecastFileID, preview }, forecastFileID, preview, { sumPeriodValues });

export const aggregateSheetForecastFileHierarchy = forecastID => (dispatch) => {
    dispatch({
        type: ActionType.AGGREGATE_SHEET_FORECAST_FILE_HIERARCHY,
        forecastID
    });

    return dispatch(networkAPIAction(SheetForecastApi, 'sheetForecastAggregateFileHierarchyGet', NetworkActionPrefix.AGGREGATE_SHEET_FORECAST_FILE_HIERARCHY_PREFIX, { forecastID }, forecastID));
};

export const touchSheetForecastFile = (sheetForecastID, sheetForecastFileID, statusID, responsibleUserNote) =>
    networkAPIAction(SheetForecastFileApi, 'sheetForecastFileTouchGet', NetworkActionPrefix.TOUCH_SHEET_FORECAST_FILE_PREFIX, { sheetForecastID, sheetForecastFileID, statusID, responsibleUserNote }, sheetForecastFileID, statusID, responsibleUserNote);
export const sendSheetForecastFileReminder = (sheetForecastID, sheetForecastFileID, statusID, managerNote) =>
    networkAPIAction(SheetForecastFileApi, 'sheetForecastFileSendReminderGet', NetworkActionPrefix.SHEET_FORECAST_FILE_SEND_REMINDER_PREFIX, { sheetForecastID, sheetForecastFileID, statusID, managerNote }, sheetForecastFileID, statusID, managerNote);
export const deleteSheetForecastFile = (sheetForecastID, sheetForecastFileID) => sheetForecastFileActionSet.removeSheetForecastFile(sheetForecastID, sheetForecastFileID);

const sheetForecastRelatedSheetActionSet = nestedEntityLifecycleActionSet('SheetForecastRelatedSheet', 'SHEET_FORECAST_RELATED_SHEET', 'sheetForecast', 'sheetForecastRelatedSheet', SheetForecastRelatedSheetApi, {
    add: true
}, true);
export const addSheetForecastRelatedSheet = (sheetForecastID, sheetForecastRelatedSheet, sync) => sheetForecastRelatedSheetActionSet.addSheetForecastRelatedSheet(sheetForecastID, sheetForecastRelatedSheet, sync);
export const removeSheetForecastRelatedSheet = (sheetForecastID, sheetForecastRelatedSheetID) => sheetForecastRelatedSheetActionSet.removeSheetForecastRelatedSheet(sheetForecastID, sheetForecastRelatedSheetID);

export const setSheetForecastFileUserAccesses = (sheetForecastID, sheetForecastFileID, userIDs) =>
    networkAPIAction(new SheetForecastFileUserAccessApi(), 'sheetForecastFileUserAccessSetFileUserAccessesPut', NetworkActionPrefix.SET_SHEET_FORECAST_FILE_USER_ACCESSES_PREFIX, { sheetForecastID, sheetForecastFileID, userIDs }, userIDs, sheetForecastFileID);

const sheetForecastNotificationActionSet = entityLifecycleActionSet('SheetForecastNotification', 'SHEET_FORECAST_NOTIFICATION', 'sheetForecastNotification', SheetForecastNotificationApi, {
    add: true
}, true);
export const addSheetForecastNotification = (sheetForecastNotification, sync) => sheetForecastNotificationActionSet.addSheetForecastNotification(sheetForecastNotification, sync);

export const loadAllSheetGoogleTemplateCopiedRangeValueTypes = () =>
    networkAPIAction(new SheetGoogleTemplateCopiedRangeValueTypeApi(), 'sheetGoogleTemplateCopiedRangeValueTypeLoadAllGet', NetworkActionPrefix.LOAD_ALL_SHEET_GOOGLE_TEMPLATE_COPIED_RANGE_VALUE_TYPE_PREFIX, {});

export const loadAllSheetConfigurationForecastDownloadRules = () =>
    networkAPIAction(new SheetConfigurationForecastDownloadFromSheetRuleApi(), 'sheetConfigurationForecastDownloadFromSheetRuleLoadAllGet', NetworkActionPrefix.LOAD_ALL_SHEET_CONFIGURATION_FORECAST_DOWNLOAD_RULES_PREFIX, {});

export const loadAllSheetConfigurationForecastUploadRules = () =>
    networkAPIAction(new SheetConfigurationForecastUploadToSheetRuleApi(), 'sheetConfigurationForecastUploadToSheetRuleLoadAllGet', NetworkActionPrefix.LOAD_ALL_SHEET_CONFIGURATION_FORECAST_UPLOAD_RULES_PREFIX, {});

export const loadAllExcelGenerationIndicatorDepthRules = () =>
    networkAPIAction(SheetExcelGenerationIndicatorDepthRuleApi, 'sheetExcelGenerationIndicatorDepthRuleLoadAllGet', NetworkActionPrefix.LOAD_ALL_EXCEL_GENERATION_INDICATOR_RULES_PREFIX);

export const loadAllExcelGenerationValueWriteRules = () =>
    networkAPIAction(SheetExcelGenerationValueWriteRuleApi, 'sheetExcelGenerationValueWriteRuleLoadAllGet', NetworkActionPrefix.LOAD_ALL_EXCEL_GENERATION_VALUE_WRITE_RULES_PREFIX);
